export function useGoogleAnalytics() {
  const digitalData = ({
    event,
    eventDetail,
    contentTitle,
    contentUrl,
    ctaLabel,
  }) => {
    // console.log({
    //   event,
    //   eventDetail,
    //   contentTitle,
    //   contentUrl,
    //   ctaLabel,
    // });
    window.digitalData.push({
      event,
      pageEvent: {
        eventInfo: { eventDetail, contentTitle, contentUrl, ctaLabel },
      },
    });
  };

  return { digitalData };
}
